/**
 * The work panel, UNDER its own row (the #329 pattern): the row you opened
 * stays in view above what you are reading, and the table keeps its full
 * width while nothing is open.
 */
import React from 'react';

export default function DetailRow({ id, colSpan, label, children }: { id: string; colSpan: number; label: string; children: React.ReactNode }) {
  // A heading the page outline can hold the panel by (h1 page, h2 panel, h3 its sections); visible text already says it.
  return (
    <tr className="board-detailrow" id={id}>
      <td colSpan={colSpan}>
        <section className="board-detail" aria-labelledby={`${id}-h`}>
          <h2 id={`${id}-h`} className="board-sr">{label}</h2>
          {children}
        </section>
      </td>
    </tr>
  );
}
